import { logEvent as firebaseLogEvent, setUserProperties as firebaseSetUserProperties, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { analytics } from "../config/firebase";

// Define strict event names to prevent typos
export const ANALYTICS_EVENTS = {
    PAGE_VIEW: 'page_view',
    LOGIN: 'login',
    SIGN_UP: 'sign_up',
    BUTTON_CLICK: 'button_click',
    LINK_CLICK: 'link_click',
    FORM_SUBMIT: 'form_submit',
    ERROR: 'error',
    // Custom business events
    ENGAGEMENT: 'user_engagement',
    CONVERSION: 'conversion'
};

const isDev = import.meta.env.DEV;

/**
 * Logs a custom event to Firebase Analytics
 * @param {string} eventName - Name of the event (use constants from ANALYTICS_EVENTS)
 * @param {object} params - Additional parameters for the event
 */
export const logEvent = (eventName, params = {}) => {
    if (analytics) {
        try {
            firebaseLogEvent(analytics, eventName, params);
            if (isDev) {
                console.log(`[Analytics] Event: ${eventName}`, params);
            }
        } catch (error) {
            console.warn('[Analytics] Failed to log event:', error);
        }
    } else {
        if (isDev) console.log(`[Analytics (Mock)] Event: ${eventName}`, params);
    }
};

/**
 * Sets user properties for audience segmentation
 * @param {object} properties - User properties (e.g., plan_type, user_role)
 */
export const setUserProperties = (properties) => {
    if (analytics) {
        try {
            firebaseSetUserProperties(analytics, properties);
            if (isDev) {
                console.log('[Analytics] Set User Properties:', properties);
            }
        } catch (error) {
            console.warn('[Analytics] Failed to set user properties:', error);
        }
    }
};

/**
 * Logs a page view event explicitly
 * @param {string} pagePath - The path of the page viewed
 * @param {string} pageTitle - The title of the page
 */
export const logPageView = (pagePath, pageTitle) => {
    logEvent(ANALYTICS_EVENTS.PAGE_VIEW, {
        page_path: pagePath,
        page_title: pageTitle || document.title,
        page_location: window.location.href
    });
};
